/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AutomationType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import HelpText from './HelpText/index'
import React from 'react'
import Toggle from './Toggle/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AutomationType({
  children,
  viewPath = "/DesignSystem/EditAutomation/AutomationType"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let automationTypesValueData = fromData.useDataValue({ viewPath,
context: 'automation_types',
})
  return (<React.Fragment
>
<div
  data-testid="AutomationType.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-CVNh8': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="AutomationType.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Type"
 color={dtColorsNeutral900}
 size="normal"
 weight="semibold"
 marginRight={dtSpaceXxs}
/>
</div>
<HelpText
  viewPath={`${viewPath}/HelpText`}
/>
<div
  data-testid="AutomationType.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(automationTypesValueData) && automationTypesValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="type"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Toggle(${item?.id ?? item?._id ?? index})`}
      >
<Toggle
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Toggle(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }